import { exclusionsModalEvents } from '../../../utils/events/exclusions.events';
import React, { Fragment, useState } from 'react';
import { Modal } from '@toluna-ui-toolkit/modals';
import { Loader } from '@toluna-ui-toolkit/loader';
import { ExclusionsModalBody, ExclusionsWrapper } from './Exclusions.style';
import {useEvent} from "../../common/hooks/useEvent.hook";

export const Exclusions = ({ config }: any) => {
    const [showExclusionsModal, setShowExclusionsModal] = useState(false);
    const [isLoadExclusionsModal, setIsLoadExclusionsModal] = useState(false);

    //TODO: Remove once https://toluna.atlassian.net/browse/TIP-2216 is completed.
    const handleShowModal = () => {
        setIsLoadExclusionsModal(true);
        const exclusionsScript = document.getElementById('exclusions-script');

        if (exclusionsScript) {
            exclusionsScript?.parentNode?.removeChild(exclusionsScript);
        }

        window.tcp.exclusions.config = config;
        let exclusions = document.createElement('script');
        exclusions.type = 'text/javascript';
        exclusions.async = true;
        exclusions.src =
            config?.urls?.exclusionsBundleUrl ??
            'https://ti2020-qa.s3.amazonaws.com/ts-exclusions/toluna-qab/bundle.js';
        exclusions.id = 'exclusions-script';
        let script = document.getElementsByTagName('script')[0];
        script?.parentNode?.insertBefore(exclusions, script);
        setShowExclusionsModal(true);
    };

    const handleHideModal = () => {
        setShowExclusionsModal(false);
    }

    useEvent({ name: exclusionsModalEvents.SHOW_EXCLUSIONS, handler: () => handleShowModal() });
    useEvent({ name: exclusionsModalEvents.HIDE_EXCLUSIONS, handler: () => handleHideModal() });
    useEvent({ name: exclusionsModalEvents.LOAD_EXCLUSIONS, handler: () => setIsLoadExclusionsModal(false) });

    return showExclusionsModal ? (
        <ExclusionsWrapper>
            <Modal
                customStyles={{
                    width: '701px',
                    height: 'auto',
                }}
                showModal={showExclusionsModal}
            >
                <ExclusionsModalBody>
                    {isLoadExclusionsModal && (
                        <Loader
                            customStyle={{
                                margin: '50% 100px',
                            }}
                        />
                    )}
                    <div id="ti-exclusions-app" />
                </ExclusionsModalBody>
            </Modal>
        </ExclusionsWrapper>
    ) : (
        <Fragment />
    );
};